import { IList, IRecord } from '@common/types/';
import { get, pick } from 'lodash';
import { Dimensions, Platform, StyleSheet } from 'react-native';
import { useSelector } from 'react-redux';

import { AppVersion } from 'click-types';
import { appInfoSelector } from '@common/redux/selectors/app';
import {
  isPercentDimension,
  getNumber,
} from '@common/screens/RenderScreen/ObjectRender/ObjectRenderV4';

const createStyle = (attrs: IList, records: IRecord[]) => {
  const appInfo = useSelector(appInfoSelector);
  const isV4 = appInfo?.version === AppVersion.V4;
  const style = attrs.style || {};
  let width = style.width;

  if (isPercentDimension(style.width) && Platform.OS !== 'web') {
    const percent = getNumber(style.width) || 100;
    width = Dimensions.get('screen').width * (percent / 100);
  }

  const itemMaxHeight = get(
    attrs,
    'databaseOptions.options.itemMaxHeight',
    false
  );
  return StyleSheet.create({
    loading: {
      ...pick(attrs, ['marginTop', 'marginLeft', 'width', 'zIndex', 'height']),
      justifyContent: 'center',
      alignItems: 'center',
      ...(isV4 && pick(style, ['top', 'left', 'bottom', 'right', 'position'])),
    },

    loadMoreText: {
      fontSize: 14,
      textDecorationLine: 'underline',
      fontWeight: 'bold',
      textAlign: 'center',
    },

    cusListWrapper: {
      ...pick(attrs, [
        'marginTop',
        'marginLeft',
        'width',
        'backgroundColor',
        'opacity',
        'zIndex',
        // uncomment this line to scroll custom-list element based on canvas height
        // 'height',
      ]),
      ...(((!(records?.length || 0) && Platform.OS === 'web') ||
        attrs.isWeb) && {
        // comment for related 1842: fix visible scroll when list empty record
        overflowX: attrs.isWeb
          ? 'hidden'
          : records?.length === 0
          ? 'visible'
          : 'scroll',
        overflowY: 'visible',
      }),
      ...(itemMaxHeight && {
        maxHeight: 110,
      }),
      ...(isV4 &&
        pick(style, [
          'top',
          'left',
          'bottom',
          'right',
          'position',
          'transform',
        ])),
      width,
    },

    emptyListWrapper: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      zIndex: attrs.zIndex,
    },

    emptyRecord: {
      ...pick(attrs, ['marginTop', 'marginLeft', 'height', 'width']),
      ...(isV4 && pick(style, ['top', 'left', 'bottom', 'right', 'position'])),
    },
  });
};

export default createStyle;
